import { dataIdFromObject } from '@sketch/graphql-cache'

// Components
import { handleFetchMore } from '@sketch/components'

// Hooks
import { useFlag } from '@sketch/modules-common'
import { useSortingSettings } from 'modules/shares/hooks/useSortSettings'

// Types
import { useGetCollectionSharesQuery } from '@sketch/gql-types'

interface UseCollectionProps {
  projectId: string
  collectionId: string
  search?: string
}

// Helpers
const entriesPath = ['project', 'collection', 'shares', 'entries']

export const useCollectionsShares = ({
  projectId,
  collectionId,
  search,
}: UseCollectionProps) => {
  const isSearchFilterSortOn = useFlag('search-filter-sort')
  const { sort } = useSortingSettings()

  const { data, loading, error, fetchMore } = useGetCollectionSharesQuery({
    variables: {
      projectIdentifier: projectId,
      collectionIdentifier: collectionId,
      search: { name: search },
      after: null,
      sortOrder: isSearchFilterSortOn ? sort : undefined,
    },
  })

  const after = data?.project.collection.shares.meta.after || null

  const loadMoreHandler = handleFetchMore(fetchMore, entriesPath, {
    dataIdFromObject,
    after,
  })

  return {
    project: data?.project,
    loading,
    error,
    fetchMore: loadMoreHandler,
  }
}
